import { Component, OnInit, HostListener, ElementRef, ViewChild, Output, EventEmitter } from '@angular/core';

import { FormBuilder, FormGroup, NgModel, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { LoaderService } from "../../../../../common-items/services/loader.service";
import { ResetPasswordService } from '../../services/reset-password.service';
import { HttpErrorResponse } from '@angular/common/http';
import { HelperService } from 'src/common-items/services/helper.service';

@Component({
  selector: 'cp-update-password',
  templateUrl: './update-password.component.html',
  styleUrls: ['./update-password.component.less']
})

export class updatePasswordComponent implements OnInit {
  @Output() tokenExpired: EventEmitter<boolean> = new EventEmitter();
  userName: string;
  model: any = {
    newPassword: '',
    confirmPassword: ''
  }
  resetPwdForm: FormGroup;
  isLowerCase : boolean;
  isUpperCase : boolean;
  isOneDigit : boolean;
  isSpecialChar : boolean;
  isMinlength : boolean;
  wholePassword: boolean = false;
  hideToolTip: boolean = true;
  isPasswordMatched: boolean = false;
  isConfirmPassword: boolean = false;
  isPasswordSet: boolean = false;
  verificationToken: string = "";
  errorMessage: string = "";
  invalidPassword: boolean = false;
  bankingUrl: string = 'https://onlinebanking-prelaunch.connectpay.com/';
  @ViewChild('newPassword') password: NgModel;

  constructor(
    private eRef: ElementRef, 
    private _fb: FormBuilder, 
    private router: Router, 
    private resetPwdService: ResetPasswordService,
    private helperService: HelperService,
    public loaderService :LoaderService) { }

  @HostListener('document:click', ['$event'])
  clickout(event) {
    let ttLabelElement = this.eRef.nativeElement.querySelector('.label-tooltip');
    if (ttLabelElement && !ttLabelElement.contains(event.target)) {
      this.hideToolTip = true;
    }
  }

  ngOnInit() { 
    this.userName = this.resetPwdService.userName;
    this.intialiseForm();
  }
  intialiseForm() {
    this.resetPwdForm = this._fb.group({
      
      'newPassword': ['', Validators.required],
      'confirmPassword': ['', [Validators.required]]
      
    })
  }

  checkPasswordStrength(){
    let value = this.resetPwdForm.get('newPassword').value;
    let cnfmPswd = this.resetPwdForm.get('confirmPassword').value;
    if(cnfmPswd){
      this.checkPasswords();
    }

    let isInvalidValidPassword = true;

    // let value = this.password.control.value;
    this.isLowerCase = this.helperService.lowerCaseRegx.test(value);
    this.isUpperCase = this.helperService.upperCaseRegx.test(value);
    this.isOneDigit = this.helperService.digitCaseRegx.test(value);
    this.isSpecialChar = this.helperService.specCharCaseRegx.test(value);
    this.wholePassword = this.helperService.wholePasswordRegex.test(value);
    this.isMinlength = value.length >= 8 && value.length <= 20;
    isInvalidValidPassword = this.isLowerCase && isInvalidValidPassword;
    isInvalidValidPassword = this.isUpperCase && isInvalidValidPassword;
    isInvalidValidPassword = this.isOneDigit && isInvalidValidPassword;
    isInvalidValidPassword = this.isSpecialChar && isInvalidValidPassword;
    isInvalidValidPassword = this.isMinlength && isInvalidValidPassword;
    isInvalidValidPassword = this.wholePassword && isInvalidValidPassword;
    // // Check length at least 8 chars
    // isInvalidValidPassword = isInvalidValidPassword && value.length >= 8;

    this.invalidPassword = isInvalidValidPassword;
  }
  

  checkPasswords() {
    let password = this.resetPwdForm.get('newPassword').value;
    let confPassword = this.resetPwdForm.get('confirmPassword').value;

    if (confPassword == '' || password == '') {
      this.isConfirmPassword = true;
    }
    else if (password != confPassword) {
      this.isConfirmPassword = false;
    }
    else {
      this.isConfirmPassword = true;
    }

  }
  /**
   * This is the checkValidUser function
   * @param No
   * @returns void
   */
   checkValidUser(): void | boolean {
    if (!this.resetPwdForm.valid) {
      return this.makeFormDirty();
    }
    // this.isFieldRequired = false;
    this.setPassword();
  }
/**
   * This is the makeFormDirty function
   * @param No
   * @returns void
   */
 makeFormDirty(): boolean {
  let controls = <any>(
    Object.keys(this.resetPwdForm.controls).map(
      control => this.resetPwdForm.controls[control]
    )
  );
  controls.forEach(control => {
    control.markAsTouched();
    control.markAsDirty();
  });

  return false;
}
  setPassword() {
    this.loaderService.show();

    if (this.model.newPassword != this.model.confirmPassword) {
      this.isPasswordMatched = true;
      this.loaderService.hide();
      return false;
    } else {
      this.isPasswordMatched = false;
    }

    const data = {
      password:  this.resetPwdForm.get('newPassword').value
    }

    this.resetPwdService
      .resetPassword(data)
      .subscribe(res => {
        if (res.status == 'SUCCESS') {
          this.loaderService.hide()
          // this.bankingUrl = res.response.redirectUrl;
          this.helperService.redirectUrl = res.response.redirectUrl;
          sessionStorage.clear();
          this.tokenExpired.emit(true);
        } else {
          let linkExpireCodes = ['INVALID_VERIFICATION_TOKEN', 'VERIFICATION_TOKEN_NOT_FOUND', 'INVALID_LINK', 'SESSION_EXPIRED']; 
          if(linkExpireCodes.indexOf(res.errorCode) > -1) {
            this.tokenExpired.emit(false);
            sessionStorage.clear();
            this.loaderService.hide();
            return;
          }
          this.loaderService.hide();
          this.errorMessage = this.helperService.checkErrorMessage(res.errorCode);
        }
      }, (error: HttpErrorResponse) => this.onFailedResponse(error.error.errorCode));
  }

  onFailedResponse(code: string) {
    this.loaderService.hide();
    this.errorMessage = this.helperService.checkErrorMessage(code);
  }

  check() {
    if (this.password.hasError('pattern')) {
      this.hideToolTip = false;
    } else {
      this.hideToolTip = true;
    }
  }

  proceedToLoginPage() {
    this.router.navigate(['/']);
  }

}
